import { render, staticRenderFns } from "./editValidation.vue?vue&type=template&id=bc6b79aa&scoped=true"
import script from "./editValidation.vue?vue&type=script&lang=js"
export * from "./editValidation.vue?vue&type=script&lang=js"
import style0 from "./editValidation.vue?vue&type=style&index=0&id=bc6b79aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6b79aa",
  null
  
)

export default component.exports